import MenuText from "./MenuText";

export default MenuText;
